import { render, staticRenderFns } from "./StopListMenuItem.vue?vue&type=template&id=67381d50&scoped=true&"
import script from "./StopListMenuItem.vue?vue&type=script&lang=js&"
export * from "./StopListMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./StopListMenuItem.vue?vue&type=style&index=0&id=67381d50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67381d50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
